import GSAP from 'gsap'
import Close from '../../../assets/icons/close.svg'
import Story from './Story'
import Scroll from '../../components/Scroll'
export default class Accompagnement {
  constructor() {
    //setup
    this.menuLink = document.querySelector('.sofaPoint')
    this.tl = new GSAP.timeline({ paused: true, reversed: true })

    //Method
    this.event()
    this.createPage()
    this.createStory()
    this.closePage()
  }
  event() {
    this.menuLink.addEventListener('click', this.togglePage.bind(this))
  }
  createPage() {
    //Page
    this.page = document.createElement('div')
    this.page.classList.add('accompagnement')
    document.body.appendChild(this.page)

    //Page Wrapper
    this.pageWrapper = document.createElement('div')
    this.pageWrapper.className = 'page_wrapper'
    this.pageWrapper.dataset.scroll = 'data-scroll'
    this.page.appendChild(this.pageWrapper)

    //Page content
    this.pageContent = document.createElement('div')
    this.pageContent.className = 'page_content'
    this.pageWrapper.appendChild(this.pageContent)

    //title
    this.pageTitle = document.createElement('h2')
    this.pageTitle.innerHTML = 'Nous sommes tous <strong>Designers</strong>'
    this.pageContent.appendChild(this.pageTitle)

    //Texte
    this.pageDescription = document.createElement('p')
    this.pageDescription.innerHTML = 'Je vous accompagne dans cette aventure collective et créative'
    this.pageContent.appendChild(this.pageDescription)

    //Texte
    this.pageDescriptionSecond = document.createElement('p')
    this.pageDescriptionSecond.innerHTML = 'Prochainement disponible'
    this.pageContent.appendChild(this.pageDescriptionSecond)

    //Close
    this.closeBtn = document.createElement('img')
    this.closeBtn.className = 'closePage'
    this.closeBtn.src = Close
    this.page.appendChild(this.closeBtn)
  }
  createStory() {
    this.story = new Story()
    this.pageWrapper.appendChild(this.story.story)
  }
  togglePage() {
    this.tl.clear()
    this.tl
      .to(this.page, {
        autoAlpha: 1,
        display: 'block',
        ease: 'Power1.easeOut',
        duration: 1,
      })
      .fromTo(
        this.pageTitle,
        {
          autoAlpha: 0,
          y: 10,
        },
        { autoAlpha: 1, y: 0, duration: 0.5 }
      )
      .fromTo(
        this.pageDescription,
        {
          autoAlpha: 0,
          y: 10,
        },
        { autoAlpha: 1, y: 0, duration: 0.5 }
      )

    if (!this.tl.isActive()) {
      this.tl.reversed() ? this.tl.play(0).timeScale(1) : this.tl.timeScale(2).reverse()
    }
  }
  closePage() {
    this.closeBtnAc = document.querySelector('.accompagnement .closePage')
    this.closeBtnAc.addEventListener('click', () => {
      if (!this.tl.isActive()) {
        this.tl.timeScale(2).reverse()
      }
    })
    // this.page.addEventListener('click', () => {
    //   if (!this.tl.isActive()) {
    //     this.tl.timeScale(2).reverse()
    //   }
    // })
  }

  update() {
    this.scroll = new Scroll()
  }
}
